export const HELP_PERSONAS = Object.freeze({
  COLLECTOR: "collector",
  REPORTS: "reports",
  TRUSTED_OPERATOR: "trustedOperator",
  COMPANY_ADMIN: "companyAdmin",
  PLATFORM_ADMIN: "platformAdmin",
});

const HELP_DEFAULT_SECTION_BY_PERSONA = Object.freeze({
  [HELP_PERSONAS.COLLECTOR]: "collection-and-privacy",
  [HELP_PERSONAS.REPORTS]: "verification-and-reports",
  [HELP_PERSONAS.TRUSTED_OPERATOR]: "certify-and-trusted-operations",
  [HELP_PERSONAS.COMPANY_ADMIN]: "team-and-role-management",
  [HELP_PERSONAS.PLATFORM_ADMIN]: "platform-governance-and-controls",
});

export function resolveHelpPersona({
  isPlatformAdmin,
  canManageCompanyUsers,
  canCertify,
  companyRole,
}) {
  if (isPlatformAdmin) {
    return HELP_PERSONAS.PLATFORM_ADMIN;
  }
  if (canManageCompanyUsers) {
    return HELP_PERSONAS.COMPANY_ADMIN;
  }
  if (canCertify) {
    return HELP_PERSONAS.TRUSTED_OPERATOR;
  }
  if ((companyRole || "").toLowerCase() === "reports") {
    return HELP_PERSONAS.REPORTS;
  }
  return HELP_PERSONAS.COLLECTOR;
}

export function getDefaultHelpSectionId(persona) {
  return (
    HELP_DEFAULT_SECTION_BY_PERSONA[persona] ||
    HELP_DEFAULT_SECTION_BY_PERSONA[HELP_PERSONAS.COLLECTOR]
  );
}
